import * as React from 'react';
export const firsttennesseeSvg = React.forwardRef(
  function firsttennesseeSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#fff',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0V0Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M32 32H21.07l4.27-6.05L32 24.2V32Zm0-25.76V21.6l-2.8-1.68 2.66-7.05-9.47 4.7-7.75-1.76.07 6.54-8.18 6.13 9.83-.42 2.3 3.94H0v-2.94c5.88-9.14 17.94-20.3 32-22.82Z',
        fill: '#003B80',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v3.9c-11.91.6-26.19 9.5-32 16.4V0Z',
        fill: '#ED1B2E',
      }),
    );
  },
);
firsttennesseeSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var firsttennessee = {
  category: 'brand',
  colorable: false,
  name: 'firsttennessee',
  svg: firsttennesseeSvg,
};
